module.exports = __webpack_public_path__ + "static/media/play-egg-player.52cfddb4.png";